export const CHECKLIST_SECTIONS = [
  {
    key: "sezione1",
    title: "1. Dati anagrafici e qualificazioni dell'impresa",
    items: [
      { key: "modulo_raccolta_dati", label: "Modulo raccolta dati azienda (compilato e firmato dal legale rappresentante)", template: "modulo_raccolta_dati" },
      { key: "visura_camerale", label: "Visura camerale aggiornata (CCIAA)" },
      { key: "atto_costitutivo", label: "Atto costitutivo / statuto aggiornato (se richiesto in upload)" },
      { key: "id_legale_rappresentante", label: "Documento di identità e codice fiscale del legale rappresentante" },
      { key: "procura_delega", label: "Eventuale procura/delega interna a favore del soggetto che opera sulla piattaforma GSE" },
    ],
  },
  {
    key: "sezione2",
    title: "2. Requisiti fiscali e contributivi",
    items: [
      { key: "durc", label: "DURC in corso di validità (se richiesto nei modelli GSE)" },
      { key: "aiuti_stato", label: "Autodichiarazione aiuti di Stato / assenza di aiuti illegali o incompatibili (modello standard GSE, se previsto)" },
      { key: "impresa_bonis", label: "Autodichiarazione di impresa in bonis (assenza di procedure concorsuali), se prevista" },
    ],
  },
  {
    key: "sezione3",
    title: "3. Descrizione del progetto e dei beni",
    items: [
      { key: "relazione_progetto", label: "Relazione sintetica interna sul progetto di investimento (descrizione beni, finalità, inserimento nel ciclo produttivo)" },
      { key: "elenco_beni", label: "Elenco analitico dei beni oggetto di iperammortamento (descrizione tecnica, impianto/reparto, sede produttiva, importo previsto)" },
    ],
  },
  {
    key: "sezione4",
    title: "4. Contratti e preventivi (fase di prenotazione)",
    items: [
      { key: "contratto_ordine", label: "Contratto di acquisto / conferma d'ordine" },
      { key: "preventivi_offerte", label: "Preventivi/offerte accettate relativi ai beni oggetto di investimento" },
      { key: "bozza_leasing", label: "Eventuali bozze di contratto di leasing per i beni da acquisire in leasing" },
    ],
  },
  {
    key: "sezione5",
    title: "5. Documentazione economico-finanziaria di base",
    items: [
      { key: "prospetto_investimenti", label: "Prospetto riepilogativo degli investimenti previsti (totale e per bene)" },
      { key: "cronoprogramma", label: "Cronoprogramma sintetico di realizzazione e interconnessione (inizio/fine lavori e messa in funzione)" },
    ],
  },
  {
    key: "sezione6",
    title: "6. Dichiarazioni del legale rappresentante (fase di prenotazione)",
    items: [
      { key: "dichiarazione_sostitutiva", label: "Dichiarazione sostitutiva (art. 47 DPR 445/2000) con dati impresa e legale rappresentante, descrizione investimenti, ubicazione impianti, impegno rispetto requisiti tecnici, impegno alla presentazione della documentazione tecnica e perizie" },
    ],
  },
];

export const SABATINI_SECTION = {
  key: "sabatini",
  title: "Nuova Sabatini — documenti dedicati",
  items: [
    { key: "sab_visura", label: "Visura camerale aggiornata" },
    { key: "sab_bollo", label: "Marca da bollo da 16 €" },
    { key: "sab_banca", label: "Nome della banca / istituto finanziario dove verrà richiesto il finanziamento o il leasing" },
    { key: "sab_id", label: "Documento di identità del legale rappresentante" },
    { key: "sab_preventivi", label: "Preventivi di spesa dei beni oggetto di finanziamento" },
    { key: "sab_iban", label: "IBAN dell'impresa" },
    { key: "sab_bilancio", label: "Ultimo bilancio approvato" },
    { key: "sab_ula", label: "Calcolo delle ULA (Unità di Lavoro Annue)" },
    { key: "sab_spid", label: "Credenziali SPID del legale rappresentante" },
  ],
};
